const testFirebaseConfig =
  process.env.NODE_ENV === 'test'
    ? {
        apiKey: 'test-api-key',
        authDomain: 'can-eat-test.firebaseapp.com',
        databaseURL: 'https://can-eat-test-default-rtdb.firebaseio.com',
        projectId: 'can-eat-test',
        storageBucket: 'can-eat-test.appspot.com',
        messagingSenderId: '123456789',
        appId: '1:123456789:web:test'
      }
    : {}

const getFirebaseConfigValue = (envKey, configKey) =>
  process.env[envKey] || testFirebaseConfig[configKey]

const firebaseConfig = {
  apiKey: getFirebaseConfigValue('REACT_APP_FIREBASE_API_KEY', 'apiKey'),
  authDomain: getFirebaseConfigValue(
    'REACT_APP_FIREBASE_AUTH_DOMAIN',
    'authDomain'
  ),
  databaseURL: getFirebaseConfigValue('REACT_APP_DATABASE_URL', 'databaseURL'),
  projectId: getFirebaseConfigValue(
    'REACT_APP_FIREBASE_PROJECT_ID',
    'projectId'
  ),
  storageBucket: getFirebaseConfigValue(
    'REACT_APP_FIREBASE_STORAGE_BUCKET',
    'storageBucket'
  ),
  messagingSenderId: getFirebaseConfigValue(
    'REACT_APP_FIREBASE_MESSAGING_SENDER_ID',
    'messagingSenderId'
  ),
  appId: getFirebaseConfigValue('REACT_APP_FIREBASE_APP_ID', 'appId')
}

export default firebaseConfig
